import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'

import CONTENT_ITEM_FRAGMENT from '../../../../graphql/fragments/content-item.gql'
import CastCrew from '../cast-crew'
import RentalNotes from '../rental-notes'
import styles from './content-description.css'

function ContentDescription({
  contentItem, notes, margin
}) {
  const { description, rating } = contentItem
  const { timeToBeginWatch, hoursFromFirstPlay } = notes

  return (
    <div
      className={styles.container}
      style={{
        marginLeft: margin,
        marginRight: margin
      }}
    >
      <span className={styles.breakline} />

      <div className={styles.contentFrame}>
        <div className={styles.content}>
          {description && (
            <div className={styles.description}>
              {description}
            </div>
          )}

          <CastCrew contentItem={contentItem} />

          {rating?.reason && (
            <div className={styles.ratingReason}>
              {rating.reason}
            </div>
          )}
        </div>

        {(timeToBeginWatch || hoursFromFirstPlay) && (
          <div className={styles.rentalNotesFrame}>
            <RentalNotes
              timeToBeginWatch={timeToBeginWatch}
              hoursFromFirstPlay={hoursFromFirstPlay}
            />
          </div>
        )}
      </div>
    </div>
  )
}

ContentDescription.propTypes = {
  contentItem: propType(CONTENT_ITEM_FRAGMENT).isRequired,
  notes: PropTypes.arrayOf(PropTypes.string),
  margin: PropTypes.number
}

ContentDescription.defaultProps = {
  notes: [],
  margin: 0
}

export default ContentDescription
